/**
 * Given an array of filters with repeating options, consolidates repeating
 * options into a single option with a count and sorts by count (desc) and
 * label (asc). A helper function for programmatically producing option lists
 * for filters that responds to the number of hits within a result set.
 * @param {Array} filters - An array of filter objects.
 * @returns {Array} The modified filters array, with options collapsed and sorted.
 */
const addFilterCounts = (filters) => filters.map(({
  label,
  options,
  type,
}) => ({
  label,
  options: options.reduce((acc, item) => {
    const index = acc.findIndex(({ value }) => value === item.value);
    if (- 1 < index) {
      acc[index].count += 1;
    } else {
      acc.push({
        count: 1,
        label: item.label,
        value: item.value,
      });
    }

    // Keep the array sorted; reverse chron if "Years", by count in other cases.
    const dateLabels = [
      'Years',
      'Published Date',
      'Year Granted',
    ];
    if (dateLabels.includes(label)) {
      acc.sort((optionA, optionB) => (
        parseInt(optionB.label, 10) - parseInt(optionA.label, 10)
      ));

      return acc;
    }

    acc.sort((optionA, optionB) => (optionA.count === optionB.count
      ? optionA.label.localeCompare(optionB.label)
      : optionB.count - optionA.count));

    return acc;
  }, []).map(({ count, label: optionLabel, value }) => ({
    label: `${optionLabel} (${count})`,
    value,
  })),
  type,
}));

export default addFilterCounts;
